<template>
  <v-container fluid py-0>
    <v-row>
      <v-col>
        <div class="text-center mt-9 mb-11 text-h4">
          {{ getLoggedInName }}'s Dashboard
        </div>
      </v-col>
    </v-row>
    <v-row v-if="loaded">
      <v-col>
        <div class="d-flex justify-center">
          <div
            class="d-flex flex-row flex-wrap justify-center"
            v-if="selectedRecords.length"
          >
            <div v-for="(record, index) in selectedRecords" :key="record._id">
              <v-card class="mr-7 mb-5 record-card">
                <v-card-title class="justify-space-between pb-1">
                  <a :href="`/records?record=${record._id}`">
                    {{ record.name }}
                  </a>
                  <v-tooltip max-width="30vw" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="addOrder(record, index)"
                        :disabled="showAddOrder"
                      >
                        <v-icon small>mdi-plus-thick</v-icon>
                      </v-btn>
                    </template>
                    <span>Create new order</span>
                  </v-tooltip>
                </v-card-title>
                <v-divider />
                <v-card-text>
                  <div class="text-center text-subtitle-2 pb-1">
                    <div v-if="record.orders">
                      {{ orderCount(record.orders) }}
                    </div>
                    <div v-else class="font-weight-light">
                      No orders
                    </div>
                  </div>
                  <div
                    v-for="order in record.orders"
                    :key="order.id"
                    class="text-body-2 mb-1"
                  >
                    <div class="d-flex justify-space-between align-baseline">
                      <span>{{ order.name }}</span>
                      <!-- <v-tooltip max-width="30vw" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="editOrder(order, record, index)"
                            :disabled="showAddOrder"
                          >
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Edit this order</span>
                      </v-tooltip> -->
                    </div>
                    <div class="ml-1">
                      <v-tooltip max-width="30vw" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mb-1"
                            width="24"
                            height="24"
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="toggleExpand(order._id)"
                            :disabled="showAddOrder"
                          >
                            <v-icon
                              :class="{ open: expandedOrders[order._id] }"
                            >
                              mdi-menu-right
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Show more info</span>
                      </v-tooltip>
                      <span class="ml">{{ getFrequencyString(order) }}</span>
                    </div>
                    <div class="ml-7" v-if="expandedOrders[order._id]">
                      <div>
                        <span class="font-weight-medium">Note:</span>
                        {{
                          order.description ? order.description : "&lt;None&gt;"
                        }}
                      </div>
                      <div>
                        <span class="font-weight-medium">Event:&nbsp;</span>
                        <a
                          :href="
                            `/records?record=${
                              record._id
                            }&event=${encodeURIComponent(order.event)}`
                          "
                          v-if="order.event"
                        >
                          {{ order.event }}
                        </a>
                        <span v-else>{{ "&lt;None&gt;" }}</span>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
          <div v-else class="text-h5">
            You haven't issued any orders yet
          </div>
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-if="showAddOrder"
      v-model="showAddOrder"
      width="600px"
      persistent
    >
      <AddEditOrder
        :selectedRecord="selectedRecord"
        :tree="treeRecord"
        :events="events"
        :editMode="editOrderMode"
        :existingOrder="existingOrder"
        @cancel-add-dialog="showAddOrder = !showAddOrder"
        @close-add-dialog="showAddOrder = !showAddOrder"
      ></AddEditOrder>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import AddEditOrder from "./record-viewer/AddEditOrder.vue";
import { getAllRecordsWithSpecifiedOrderIssuer } from "../../utils/api";
import { treeBuildEvents } from "../../utils/treeUtils";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "Dashboard",
  components: { AddEditOrder },
  data() {
    return {
      expandedOrders: {},
      showAddOrder: false,
      editOrderMode: false,
      existingOrder: {},
      myRecordsInDBFormat: [],
      events: {},
      selectedRecord: {},
      treeRecord: {},
      loaded: false,
    };
  },
  created() {},
  async mounted() {
    this.loaded = false;
    const recordsWithMyOrders = await getAllRecordsWithSpecifiedOrderIssuer(
      this.auth.userData.username
    );
    if (recordsWithMyOrders?.length) {
      this.myRecordsInDBFormat = recordsWithMyOrders.map((r) => r.record);
      this.$store.commit(
        "REPLACE_SELECTED_RECORDS_ARRAY",
        this.myRecordsInDBFormat
      );
      // this.myRecordsInDBFormat = cloneDeep(recordsWithMyOrders);
      // } else {
      //   this.$store.commit("REPLACE_SELECTED_RECORDS_ARRAY", recordsWithMyOrders.record);
    }
    this.loaded = true;
  },
  computed: {
    ...mapState(["auth"]),
    ...mapState({
      selectedRecords: (state) => state.records.selectedRecords,
    }),
    ...mapGetters(["getLoggedInName"]),
  },
  methods: {
    orderCount(orders) {
      const orderNum = orders.length ? orders.length : "No";
      const plural = orders.length ? "orders" : "order";
      return `${orderNum} ${plural}`;
    },
    findDBRecord(record) {
      const recs = this.myRecordsInDBFormat.filter(
        (rec) => rec._id === record._id
      );
      return recs[0];
    },
    addOrder(record) {
      this.showAddOrder = true;
      this.editOrderMode = false;
      this.selectedRecord = this.findDBRecord(record);
      this.treeRecord = record;
      this.events = treeBuildEvents(this.events, record);
    },
    editOrder(order, record) {
      this.showAddOrder = true;
      this.editOrderMode = true;
      this.existingOrder = order;
      this.selectedRecord = this.findDBRecord(record);
      this.treeRecord = record;
      this.events = treeBuildEvents(this.events, record);
    },
    getFrequencyString(order) {
      if (order.frequency && !(order.freq_count || order.freq_period)) {
        // This is an old frequency order. Parse it out.
        return this.displayOrderInfo(order);
      }
      const count = parseInt(order.freq_count, 10);
      const period = parseInt(order.freq_period, 10);
      if (count === 1) {
        return `Once every ${this.pluralize("day", period)}`;
      }
      return `${count} times every ${this.pluralize("day", period)}`;
    },
    pluralize(word, count) {
      return `${count !== 1 ? `${count} ` : ""}${word}${
        count !== 1 ? "s" : ""
      }`;
    },
    displayOrderInfo(order) {
      const pieces = order.frequency.split(" ");
      let freq = order.frequency;
      if (pieces[0] === "1") {
        freq = pieces[1];
      }
      return `Every ${freq} ${this.getExpiry(
        order.created_at,
        order.duration
      )}`;
    },
    toggleExpand(id) {
      if (this.expandedOrders[id]) {
        this.expandedOrders[id] = !this.expandedOrders[id];
      } else {
        this.$set(this.expandedOrders, id, true);
      }
    },
    formatJustDatestamp(timestamp) {
      return moment(timestamp).format("MMM Do, YYYY");
    },
    getExpiry(creation, duration) {
      if (duration?.indexOf("times") === -1) {
        const start = moment(new Date(), "YYYY-MM-DD").startOf("day");
        const m = moment(creation, "YYYY-MM-DD");
        const pieces = duration?.split(" ");
        m.add(pieces[0], pieces[1]).startOf("day");
        return `until ${m.format("MMM Do, YYYY")}`;
      } else {
        return `for a total of ${duration}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
form {
  width: 100%;
}
.close-button {
  position: absolute;
  right: 0px;
  cursor: pointer;
  z-index: 200;
  margin-top: -20px;
}
.record-card {
  min-width: 300px;
  min-height: 330px;
}
.open {
  transform: rotate(90deg);
  transition: rotate 2s;
}
</style>
